module.exports = __webpack_public_path__ + "img/phonelink_setup.6535af0f.svg";